import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
export default class MobileView extends React.Component {
  static DeviceTypes = {
    "Mobile": "mobile",
    "Desktop": "desktop"
  }
  static propTypes = {
    deviceType: PropTypes.string
  }
  static defaultProps = {
    deviceType: MobileView.DeviceTypes.Mobile,
  }
  constructor(props) {
    super(props);
    this.mobile = window.matchMedia('(max-width: 767px)');
    this.desktop = window.matchMedia('(min-width: 768px)');

    this.state = {
      isMobile: false,
    };

    if (this.mobile.matches) this.state.isMobile = true;

    if (this.desktop.matches) this.state.isMobile = false;

  }


  componentDidMount() {
    this._isMounted = true;
    this.mobile.addListener((e) => {
      if (e.matches && this._isMounted) {
        this.setState({ isMobile: true });
      }
    });
    this.desktop.addListener((e) => {
      if (e.matches && this._isMounted) this.setState({ isMobile: false });
    })
  }
  componentWillUnmount() {
    this._isMounted = false;
  }


  render() {
    return (
      <React.Fragment>
        {(this.props.deviceType == MobileView.DeviceTypes.Mobile
          && this.state.isMobile
          && <React.Fragment>{this.props.children}</React.Fragment>)}

        {(this.props.deviceType == MobileView.DeviceTypes.Desktop
          && !this.state.isMobile
          && <React.Fragment>{this.props.children}</React.Fragment>)}
      </React.Fragment>
    )
  }

}
